import { render, staticRenderFns } from "./Expert2Edit.vue?vue&type=template&id=16db59a8&scoped=true&"
import script from "./Expert2Edit.vue?vue&type=script&lang=js&"
export * from "./Expert2Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db59a8",
  null
  
)

export default component.exports